export const getUrl = (alias: string) => globalThis.urlList?.[alias.toLowerCase()];
